import { cleanName } from '../../../common/utils/text';

// Client-side validation mirroring api-reference/admin-animals.md.
// Bautizo (decisión 0015): baptized=true ⇒ name + number requeridos; una cría
// pendiente (baptized=false) puede guardarse sin ellos. Las fechas viajan como
// 'YYYY-MM-DD' (el valor crudo de <input type="date">), nunca por new Date().
const MAX_NAME = 120;
const MAX_NUMBER = 40;
const MAX_REGISTER = 60;
const MAX_APPEARANCE = 255;

export function validateAnimal(form) {
    const errors = {};
    const baptized = form.baptized !== false;
    const name = cleanName(form.name);
    const number = cleanName(form.number);

    if (baptized && !name) errors.name = 'El nombre es obligatorio.';
    else if (name.length > MAX_NAME) errors.name = `Máximo ${MAX_NAME} caracteres.`;

    if (baptized && !number) errors.number = 'El número (arete) es obligatorio.';
    else if (number.length > MAX_NUMBER) errors.number = `Máximo ${MAX_NUMBER} caracteres.`;

    if (form.register && form.register.trim().length > MAX_REGISTER) errors.register = `Máximo ${MAX_REGISTER} caracteres.`;

    if (!form.race_id) errors.race_id = 'Elegí la raza.';
    if (form.sex !== 'female' && form.sex !== 'male') errors.sex = 'Elegí el sexo.';

    if (form.appearance && form.appearance.trim().length > MAX_APPEARANCE) errors.appearance = `Máximo ${MAX_APPEARANCE} caracteres.`;

    if (form.birth && !/^\d{4}-\d{2}-\d{2}$/.test(form.birth)) errors.birth = 'Fecha inválida.';

    return errors;
}
